/**
 * AI agents (MCP). Agents sign in with OAuth: the user logs in through Speedmax ID SSO and approves
 * the agent; it then acts as that user with the user's permissions. One approval = one connection.
 */

/** Pending approval shown on the consent page (`/oauth/consent?request=`). */
export interface OAuthRequestView {
  id: string;
  clientName: string;
  /** Where the browser returns after the decision (host of the redirect URI). */
  redirectHost: string;
  /** The user's role allows AI agents (`mcp.use`). */
  allowed: boolean;
  /** The Speedmax ID account that approves (shown so a wrong account is noticed). */
  account: { name: string; username: string; email: string | null };
  /** When that account signed in through Speedmax ID for this request. */
  loginAt: string;
}

export interface McpConnection {
  id: string;
  clientName: string;
  redirectHost: string;
  createdAt: string;
  lastUsedAt: string | null;
  /** Filled in the admin view (all users). */
  user: { id: string; name: string; username: string } | null;
}

/** Path of the MCP endpoint on the app's origin. */
export const MCP_PATH = '/mcp';
